import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { useExampleNovelsAdmin } from '../hooks/use-example-novels-admin';

interface ExampleNovelsSectionProps {
  resolveResponsive: (values: { xs: number; md: number }) => number;
}

export function ExampleNovelsSection({ resolveResponsive }: ExampleNovelsSectionProps) {
  const { t } = useTranslation();
  const { loading, result, error, ensureExampleNovelsExist } = useExampleNovelsAdmin();

  return (
    <Grid size={resolveResponsive({ xs: 12, md: 6 })}>
      <Card sx={{ height: '100%', borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            {t('admin.example_novels.title')}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, flexGrow: 1 }}>
            {t('admin.example_novels.description')}
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {t('admin.example_novels.status_error', { error })}
            </Alert>
          )}

          {result && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {t('admin.example_novels.status_success', {
                createdCount: result.createdCount,
                existingCount: result.existingCount,
              })}
            </Alert>
          )}

          <Box sx={{ mt: 'auto' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={ensureExampleNovelsExist}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : undefined}
              fullWidth
            >
              {loading
                ? t('admin.example_novels.btn_creating')
                : t('admin.example_novels.btn_create')}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
}
